import * as React from 'react';
import { cn } from '@/lib/utils';

type ButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'default' | 'outline' | 'ghost' | 'primary';
  size?: 'default' | 'sm';
};

export function buttonVariants({ variant = 'default' }: { variant?: 'default' | 'outline' | 'ghost' | 'primary' }) {
  const base =
    'inline-flex items-center justify-center rounded-full font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 disabled:opacity-50 disabled:pointer-events-none';
  const variants = {
    default: 'bg-primary text-primary-foreground hover:bg-primary/90',
    primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
    outline: 'border border-primary text-primary bg-transparent hover:bg-primary/5',
    ghost: 'bg-transparent text-muted-foreground hover:text-foreground hover:bg-muted',
  }[variant];
  return cn(base, variants);
}

export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant = 'default', size = 'default', ...props }, ref) => {
    const base =
      'inline-flex items-center justify-center rounded-full font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 disabled:opacity-50 disabled:pointer-events-none';
    const sizes = {
      default: 'h-10 px-4 text-sm',
      sm: 'h-8 px-3 text-sm',
    }[size];
    const variants = {
      default: 'bg-primary text-primary-foreground hover:bg-primary/90',
      primary: 'bg-primary text-primary-foreground hover:bg-primary/90',
      outline: 'border border-primary text-primary bg-transparent hover:bg-primary/5',
      ghost: 'bg-transparent text-muted-foreground hover:text-foreground hover:bg-muted',
    }[variant];
    return <button ref={ref} className={cn(base, sizes, variants, className)} {...props} />;
  }
);
Button.displayName = 'Button';


